import { EnvironmentProviders, inject, provideAppInitializer } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { updateIntercom } from "./intercom";

export function provideIntercomRouteUpdates(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const router = inject(Router);
    router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(() => {
      updateIntercom();
    });
  });
}
